export enum FeatureFlag {
  SCOUT_INTERNAL_AGENTS = 'SCOUT_INTERNAL_AGENTS',
  SCOUT_INTERNAL_MODELS = 'SCOUT_INTERNAL_MODELS',
  SCOUT_PROMPT_ADMIN = 'SCOUT_PROMPT_ADMIN',
  SCOUT_RECORD_SUMMARIES = 'SCOUT_RECORD_SUMMARIES',
  SCOUT_DIRECT_MESSAGING = 'SCOUT_DIRECT_MESSAGING',
}
